export const getInitials = (name: string): string => {
    if (!name) return '';

    const words = name?.trim().split(' ');
    if (words.length === 1) {
      return words[0].slice(0, 2);
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  };